import React from 'react';
import './App.scss';
import {
    isIOS,
    isAndroid
} from "react-device-detect";

import { Globals } from './constants';


class AppInvite extends React.Component {

    OpenAppLink() {
        var pathArray = window.location.pathname.split('/');

        if (pathArray[2]) {
            if (isAndroid) {
                window.location.href = `https://play.google.com/store/apps/details?id=com.Khaleef.CricWickMobilink&referrer=utm_source%3D133%26utm_medium%3DWEB%26utm_content%3D${pathArray[2]}`;
            } else if (isIOS) {
                window.location.href = "https://itunes.apple.com/pk/app/jazz-cricket/id1371362811?mt=8";
            } else {
                window.location.href = "/";
            }
        }else{
            window.location.href = "/";
        }
    }

    downloadApp() {
        this.props.downloadApp();
    }

    render() {
        console.log(Globals);
        return (
            <div>
                <div className="row px-3" style={{ fontSize: '12px' }}>
                    <div className="col-12 mx-auto text-center">
                        <img className=" img-fluid mt-3" width="200px" src={ Globals.telco.length > 0 ? Globals.logo : './images/cricwick/cricwick_svg_logo.svg'} alt="" />

                    </div>
                </div>
                <div className="row" style={{ fontSize: '12px' }}>
                    <div className="col-12 mx-auto text-center">
                        <img className=" img-fluid mt-3" width="202px" src='/images/mobilink/batsman.svg' alt="" />

                    </div>
                </div>
                <div className="row" style={{ fontSize: '12px' }} >
                    <div className="col-12 text-center">
                        <div style={{ width: '80%' }} className="mx-auto">
                            <b style={{ fontSize: '14px' }}>To Experince Full Features Download App</b>
                        </div>
                    </div>

                </div>
                <div className="mx-auto text-center mt-4 d-block" style={{ width: '300px', cursor: 'pointer' }}>
                    <div onClick={() => { this.downloadApp() }} className="app-invite-btn d-inline-block">
                        Get the App
                    </div>
                    <p onClick={() => window.location.href = "/"} className="mt-1" style={{ fontSize: '12px', cursor: 'pointer' }}>
                        or Continue to web
                    </p>
                </div>

            </div>
        )
    }
}

export default AppInvite;